import React from "react";
import MenuButton from "./Menu-Button/MenuButton";
import logoTransparent from "../../assets/newLogo/logoTransparent.png";
import OverlayMenu from "./Overlay/Overlay";
import * as S from "./Styles";

interface NavbarProps {
  expandMenu: () => void;
  isMenuExpanded: boolean;
}

const NavBar = ({ isMenuExpanded, expandMenu }: NavbarProps) => {
  return (
    <S.Nav aria-label="Meny">
      {/* Desktop */}
      <S.DesktopWrapper>
        <S.NavbarLogoContainer to="/">
          <S.NavbarLogo src={logoTransparent} alt="Grønvold Bygg logo" />
        </S.NavbarLogoContainer>
        <S.NavLinkContainer>
          <S.NavLink to="/">Hjem</S.NavLink>
          <S.NavLink to="/om-oss">Om oss</S.NavLink>
          <S.NavLink to="/kontakt">Kontakt</S.NavLink>
        </S.NavLinkContainer>
      </S.DesktopWrapper>
      {/* Mobile */}
      <S.MobileWrapper>
        <S.NavbarLogoContainer to="/">
          <S.NavbarLogo src={logoTransparent} alt="Grønvold Bygg logo" />
        </S.NavbarLogoContainer>
        <S.MenuButtonContainer>
          <MenuButton toggleMenu={expandMenu} isOpen={isMenuExpanded} />
        </S.MenuButtonContainer>
        <OverlayMenu isOpen={isMenuExpanded} closeMenu={expandMenu} />
      </S.MobileWrapper>
    </S.Nav>
  );
};

export default NavBar;
